import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const HerstellerServiceConfig = {
  name: "Hersteller",
  annotations: []
} as ServiceConfig;